// removed by extract-text-webpack-plugin
module.exports = {"exampleCarouselImage":"styles__exampleCarouselImage__VVIEo","carouselDetails":"styles__carouselDetails__1hKCJ","artistDetails":"styles__artistDetails__1BKFf","artistImage":"styles__artistImage__kCGbR","artistName":"styles__artistName__2qD58","exampleSlider":"styles__exampleSlider__3S2Ds"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExampleCarousel/styles.scss
// module id = 388
// module chunks = 0